<span class="text-shui-text-moderate text-sm font-semibold">
    <ng-content></ng-content>
</span>
@if (sortDirection() === SortOrder.ASC) {
    <sh-icon icon="sort-ascending" size="sm" class="text-shs-orange"></sh-icon>
}
@if (sortDirection() === SortOrder.DESC) {
    <sh-icon icon="sort-descending" size="sm" class="text-shs-orange"></sh-icon>
}
